import React from "react";

import GnbMenuWrapper from "../util/GnbMenuWrapper";

function SinglePageLogo(props) {
    const { gotoHome, goBack } = props;

    return (
        <GnbMenuWrapper isGnbMenu2={true}>
            <li className="fl">
                <button type="button" className="back" onClick={goBack} />
            </li>
            <li className="fl" onClick={gotoHome}>
                <button type="button" className="home" />
            </li>
        </GnbMenuWrapper>
    );
}

export default SinglePageLogo;
